import React from 'react';
import * as Bixby from '$/core';
import { connect } from 'react-redux';
import ClientHelpCenterBase from '../help-center-base';
import { AppState } from '$/store';
import { CLIENT_COMPANY_EXCEL_ACCESS } from '$/core/constants';

interface IClientExcelPluginProps {
  featureFlags?: string[];
}

const ClientExcelPlugin: React.FC<IClientExcelPluginProps> = ({ featureFlags }) => {
  return (
    <div className="excel-addin-section">
      {(featureFlags || []).includes(CLIENT_COMPANY_EXCEL_ACCESS) ? (
        <ClientHelpCenterBase ignoreAccordion type={Bixby.Enums.HelpCenterItemType.ExcelPlugin} />
      ) : (
        <p>
          You are not yet authorized for the Bixby Excel Plugin. Please reach out to{' '}
          <a className="link" href="mailto:info@bixbyresearch.com?subject=Requesting access to Bixby Excel Plugin">
            Bixby
          </a>{' '}
          for assistance.
        </p>
      )}
    </div>
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    featureFlags: state.loginState.featureFlags,
  };
};

export default connect(mapStateToProps, null)(ClientExcelPlugin);
